const LOGIN_PATH = '/user/login';

/**
 * Send the browser to the Tornado-served login page, preserving the current
 * path in `next` so the user returns here after signing back in.
 *
 * This is the single place the app turns an invalid/expired session into a
 * sign-in invite. It's used both by the initial auth gate (useAuthRedirect)
 * and by the global 401 handler in the data-fetch layer, so an expired or
 * remotely-invalidated session always lands on the login page instead of a
 * generic error screen.
 */
export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;

  // Already on (or heading to) the login page — avoid redundant navigations
  // and redirect loops.
  if (window.location.pathname.startsWith(LOGIN_PATH)) return;

  const next = encodeURIComponent(window.location.pathname);
  window.location.href = `${LOGIN_PATH}?next=${next}`;
}
